/**
 * @generated SignedSource<<2c486198af928d58aa197d4dc15bd3ca>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AccountTutorQuery$variables = Record<PropertyKey, never>;
export type AccountTutorQuery$data = {
  readonly characters: ReadonlyArray<{
    readonly audience: string;
    readonly displayName: string;
    readonly id: string;
  }>;
  readonly me: {
    readonly learner: {
      readonly defaultCharacter: {
        readonly audience: string;
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type AccountTutorQuery = {
  response: AccountTutorQuery$data;
  variables: AccountTutorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Character",
  "kind": "LinkedField",
  "name": "defaultCharacter",
  "plural": false,
  "selections": [
    (v0/*:: as any*/),
    (v1/*:: as any*/)
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Character",
  "kind": "LinkedField",
  "name": "characters",
  "plural": true,
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    (v1/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountTutorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v3/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountTutorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v0/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v3/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "fbe5315e3b5a3b76cf182b6b2149c5b8",
    "id": null,
    "metadata": {},
    "name": "AccountTutorQuery",
    "operationKind": "query",
    "text": "query AccountTutorQuery {\n  me {\n    learner {\n      defaultCharacter {\n        id\n        audience\n      }\n      id\n    }\n  }\n  characters {\n    id\n    displayName\n    audience\n  }\n}\n"
  }
};
})();

(node as any).hash = "02a1628a5b708dec1ce9c37fd3ca71f7";

export default node;
